import React from 'react'
import invertColor from '../../../../util/invertColor'
import { TreasureHuntPreviewTiles } from './TreasureHuntPreviewTiles'
import './TreasureHuntPreview.scss'
import {
    STANDARD_PREVIEW_HEIGHT,
    RECTANGLE_PREVIEW_HEIGHT,
    STANDARD_MODAL_PREVIEW_HEIGHT,
    RECTANGLE_MODAL_PREVIEW_HEIGHT,
} from '../utils'

export const TreasureHuntPreview = ({
    tiles,
    layout,
    isShowCover,
    coverHeader,
    coverButtonText,
    isModal,
    colorTheme,
}) => {
    let height = isModal ? STANDARD_MODAL_PREVIEW_HEIGHT : STANDARD_PREVIEW_HEIGHT
    if (layout.cols !== layout.rows) {
        height = isModal ? RECTANGLE_MODAL_PREVIEW_HEIGHT * layout.rows : RECTANGLE_PREVIEW_HEIGHT * layout.rows
    }
    return (
        <div
            className="treasure-hunt-preview-container"
            style={{ color: `${colorTheme}`, height: `${height}px`, opacity: `${isModal ? 1 : 0.3}` }}
        >
            <TreasureHuntPreviewTiles
                tiles={tiles}
                rows={layout.rows}
                cols={layout.cols}
                colorTheme={colorTheme}
                isModal={isModal}
            />
            {isShowCover && (
                <div className="treasure-hunt-preview-cover-wrapper">
                    <div className={`treasure-hunt-preview-cover  ${isModal ? 'is-modal' : ''}`}>
                        <div className="treasure-hunt-preview-cover-header">{coverHeader}</div>
                        <button
                            className="treasure-hunt-preview-cover-btn"
                            style={{
                                color: invertColor(colorTheme, true),
                                backgroundColor: colorTheme,
                            }}
                        >
                            {coverButtonText ? coverButtonText : ''}
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
